import {
  provideNgDocApp,
  provideSearchEngine,
  NgDocDefaultSearchEngine,
  providePageSkeleton,
  NG_DOC_DEFAULT_PAGE_SKELETON,
  provideMainPageProcessor,
  NG_DOC_DEFAULT_PAGE_PROCESSORS,
} from '@ng-doc/app';
import { NG_DOC_ROUTING, provideNgDocContext } from '@ng-doc/generated';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withFetch,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ApplicationConfig } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(
      NG_DOC_ROUTING,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
    ),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideNgDocContext(),
    provideNgDocApp({
      themes: [
        {
          // Your theme ID that you can use to enable theme
          id: 'acium-dark',
          // Path to the theme, that will be used by NgDoc to load theme
          path: '../assets/themes/acium-dark.css',
        },
        {
          id: 'acium-light',
          path: '../assets/themes/acium-light.css',
        },
        {
          id: 'itopia-dark',
          path: '../assets/themes/itopia-dark.css',
        },
        {
          id: 'itopia-light',
          path: '../assets/themes/itopia-light.css',
        },
        {
          id: 'dizzion-dark',
          path: '../assets/themes/dizzion-dark.css',
        },
        {
          id: 'dizzion-light',
          path: '../assets/themes/dizzion-light.css',
        },
      ],
      defaultThemeId: 'acium-light',
    }),
    provideSearchEngine(NgDocDefaultSearchEngine),
    providePageSkeleton(NG_DOC_DEFAULT_PAGE_SKELETON),
    provideMainPageProcessor(NG_DOC_DEFAULT_PAGE_PROCESSORS),
  ],
};
